/**
 * Funnel analytics — lightweight tracker for audit flow drop-off analysis.
 * Fires events to POST /api/funnel/event (no auth, fire-and-forget).
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _sessionId = sessionStorage.getItem("funnel_session") || "";
if (!_sessionId) {
  _sessionId = `fs_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  sessionStorage.setItem("funnel_session", _sessionId);
}

const _timestamps = {};

export function funnelStart(step) {
  _timestamps[step] = Date.now();
}

export function funnelTrack(event, data = {}) {
  const durationMs = _timestamps[event] ? Date.now() - _timestamps[event] : data.duration_ms || undefined;

  const payload = {
    event,
    session_id: _sessionId,
    place_id: data.place_id || "",
    email: data.email || "",
    business_name: data.business_name || "",
    step: data.step || "",
    duration_ms: durationMs,
    error: data.error || undefined,
    metadata: data.metadata || {},
  };

  // Fire-and-forget — never block UI
  fetch(`${API}/funnel/event`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).catch(() => {});
}
